module.exports = __webpack_public_path__ + "static/media/livechat-polos.cf034f59.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/livechat-polos.svg
// module id = 824
// module chunks = 0